import Component from '../../../../../../../../../lib/component';
import template from './calendar.small.week.html';
import './calendar.small.week.scss';
import smallCalendarDay from '../calendar.small.day/calendar.small.day'
let config = {
    template: template,
    data: {
    },
    actions: {},
    beforeRender(){
    },
    afterRender() {
        this.append(new smallCalendarDay({data:{dayList:this.data.dayList}}), this.el.find('.calendar-week-comment'));
    },
    firstAfterRender() {}
};
let smallCalendarWeek= Component.extend(config);
export default smallCalendarWeek;


// WEBPACK FOOTER //
// app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.week/calendar.small.week.js